import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ImageCroper from "../../../components/Popup/ImageCroper";
import { noLogo } from "../../../assets/img";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../../redux/slice/loaderNoti";
import ErrorIcon from "@mui/icons-material/Error";
import {
  useLazyVendorViewQuery,
  useVendorEditMutation,
  useVendorStoreMutation,
} from "../../../redux/api/api";

const BringTable = () => {
  const location = useLocation();
  const type = location?.state?.type;
  const data = location?.state?.data;
  const [image, setImage] = useState("");
  const [imageErr, setImageErr] = useState(false);
  const [croper, setCroper] = useState(false);
  const navigate = useNavigate();
  const [heading, setHeading] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [headingErr, setHeadingErr] = useState(false);
  const [titleErr, setTitleErr] = useState(false);
  const [descriptionErr, setDescriptionErr] = useState(false);
  const [priority, setPriority] = useState("");
  const [pririty_Err, setPrio_Err] = useState(false);
  const dispatch = useDispatch();
  const [btn, setBtn] = useState(false);

  const toggleImagePopup = () => {
    setCroper(!croper);
  };

  // RTK QUERY
  const [addVendorApi] = useVendorStoreMutation();
  const [editVendorApi] = useVendorEditMutation();
  const [viewVendorApi] = useLazyVendorViewQuery();

  const getView = () => {
    viewVendorApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        console.log(res, "view");
        let data = res?.setting_detail;
        setImage(data?.image_url);

        //json decode
        let json = JSON.parse(data?.contents);
        // console.log(json);
        // setClient_Img(data?.image_url);
        setPriority(json?.priority);
        setTitle(json?.name);
        setDescription(json?.description);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  const submitHandle = () => {
    if (title?.length == 0 || description?.length == 0 || image?.length == 0) {
      setDescriptionErr(true);
      setTitleErr(true);
      setImageErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("priority", priority);

      formdata.append("type", 7);

      if (image?.name) {
        formdata.append("image", image);
      }

      formdata.append("name", title);
      formdata.append("description", description);

      setBtn(true);
      dispatch(saveLoader(true));
      if (location?.state?.data?.id) {
        formdata.append("setting_id", location?.state?.data?.id);

        editVendorApi(formdata)
          .unwrap()
          .then((res) => {
            setBtn(false);
            dispatch(saveLoader(false));
            navigate("/bring-tables");
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      } else {
        addVendorApi(formdata)
          .unwrap()
          .then((res) => {
            setBtn(false);
            dispatch(saveLoader(false));
            navigate("/bring-tables");
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      }
    }
  };

  return (
    <div className="dashRightView p-5 home_section trans">
      {croper && (
        <ImageCroper
          toggleImagePopup={toggleImagePopup}
          setCropImage={setImage}
        />
      )}
      <p
        className="f4 fs-sm-16 fs-md-17 fs-lg-18 fs-xl-19 fs-xxl-21 primary p-0 d-flex align-items-center gap-1 mb-4"
        role={"button"}
        onClick={() => navigate(-1)}
      >
        <KeyboardBackspaceIcon /> Bring to the Table{" "}
        {type == "edit"
          ? "Edit"
          : type == "view"
          ? "View"
          : type == "add"
          ? "Add"
          : ""}
      </p>
      <div className="w-100 searchField mt-0 bg-white ">
        <div className="w-100 d-flex flex-xxl-row flex-xl-row flex-lg-row flex-column">
          <div className="w-xxl-85 w-xl-85 w-lg-85 w-md-100">
            {/* <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Heading:
              </p>

              <div className="w-50">
                <input
                  className="w-100 editBtnSelect f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 black rounded-3 mt-2"
                  value={heading}
                  onChange={(e) => setHeading(e.target.value)}
                  disabled={type == "view" ? true : false}
                />
                {heading?.length == 0 && headingErr && (
                  <div className="d-flex gap-1 mt-2">
                    <ErrorIcon className="svg_log" />
                    <p className="err-input_log mt-1">Enter Heading</p>
                  </div>
                )}
              </div>
            </div> */}

            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Icon:<span style={{ color: "#f82a2a" }}>(80px * 80px)</span>
                {type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50 ">
                <div className="w-50">
                  {type !== "view" && (
                    <input
                      type="file"
                      className="mb-2"
                      accept="image/*"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  )}
                  <img
                    src={
                      image?.name
                        ? URL.createObjectURL(image)
                        : image
                        ? image
                        : noLogo
                    }
                    className="imgDashboard"
                    disabled={type == "view" ? true : false}
                  />
                  {image?.length == 0 && imageErr && (
                    <div className="d-flex gap-1 mt-2">
                      <ErrorIcon className="svg_log" />
                      <p className="err-input_log mt-1">Upload Icon</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Title:<span style={{ color: "#f82a2a" }}>(18words only)</span>
              </p>

              <div className="w-50">
                <input
                  className="w-100 editBtnSelect f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 black rounded-3 mt-2"
                  value={title?.substring(0, 18)}
                  onChange={(e) => setTitle(e.target.value)}
                  maxLength={18}
                  disabled={type == "view" ? true : false}
                />
                {title?.length == 0 && titleErr && (
                  <div className="d-flex gap-1 mt-2">
                    <ErrorIcon className="svg_log" />
                    <p className="err-input_log mt-1">Enter Title</p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Description:
                <span style={{ color: "#f82a2a" }}>(78words only)</span>
              </p>

              <div className="w-50">
                <textarea
                  className="w-100 editBtnSelect f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 black rounded-3 mt-2"
                  value={description?.substring(0, 78)}
                  maxLength={78}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={type == "view" ? true : false}
                />
                {description?.length == 0 && descriptionErr && (
                  <div className="d-flex gap-1 mt-2">
                    <ErrorIcon className="svg_log" />
                    <p className="err-input_log mt-1">Enter Description</p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Priority Status:
                {type == "add" && type !== "view" && <span>*</span>}
              </p>

              <div className="w-50">
                <input
                  className="w-100 editBtnSelect f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 black rounded-3 mt-2"
                  type="number"
                  onChange={(e) => setPriority(e.target.value)}
                  value={priority}
                  disabled={type == "view" ? true : false}
                />
                {priority?.length == 0 && pririty_Err && (
                  <div className="d-flex gap-1 mt-2">
                    <ErrorIcon className="svg_log" />
                    <p className="err-input_log mt-1">Enter Priority Status</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex ac-jb">
        <button
          onClick={() => navigate(-1)}
          className="pointerView cust-btn addbtn ms-1 mt-0 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 px-5 rounded"
        >
          Back
        </button>
        <button
          onClick={() => submitHandle()}
          className={`pointerView cust-btn addbtn ms-1 mt-0 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 px-5 rounded ${
            btn ? "opacity-50" : ""
          }`}
          disabled={btn}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default BringTable;
